import styled from 'styled-components/macro'

const ResultInfo = styled.span`
  color: #4a4a4a;
  font-size: 12px;
  line-height: 14px;
`
export default ResultInfo
